import type { TBaseDialog } from '@crehana/compass.ui';

export interface ModernModalProps extends Pick<TBaseDialog, 'className'> {
  title?: string;
  isOpen: boolean;
  onClose: () => void;
  withHeader?: boolean;
  onConfirm?: () => void;
  typeConfirmButton?: TYPE_CONFIRM_BUTTON;
  labelCloseButton?: string;
  children: React.ReactNode;
  labelConfirmButton?: string;
  disableConfirmButton?: boolean;
  centeredButtons?: boolean;
  headerIcon?: React.ReactNode;
  withTopCloseButton?: boolean;
}

export enum TYPE_CONFIRM_BUTTON {
  ALERT = 'alert',
  PRIMARY = 'primary',
  WARNING = 'warning',
}

export enum SIZE_ICON_MODERN_MODAL {
  S = 'S',
  M = 'M',
}

export interface WrapperIconColor {
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
}
